/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react"; // React Stuff
// Common
import FadeIn from "../common/FadeIn";
import StatusBlock from "../common/StatusBlock";
//Packages
import axios from "axios";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { isAuthenticated } from "./services/auth"; //import auth
import { Navigate } from "react-router-dom";
//Images and Icons
import { MdOutlineCancel, MdAddCircle, MdModeEdit, MdPassword } from "react-icons/md";
import TutorAddForm from "./page-parts/TutorAddForm";

const TutorList = () => {
  const [tutors, setTutors] = useState([]);
  const [tutorForEdit, setTutorForEdit] = useState("");
  // Error and Click Handling
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [submitClicked, setSubmitClicked] = useState(false);
  // View Mode
  const [viewMode, setViewMode] = useState("view");

  // Get the Tutor Details
  useEffect(async () => {
    const tutorRequest = await axios.get(`/api/admin/manage/tutor`, {
      withCredentials: true,
    });
    return setTutors(tutorRequest.data);
  }, []);

  //Fetch new data as required
  const fetchNewData = async () => {
    const tutorRequest = await axios.get(`/api/admin/manage/tutor`, {
      withCredentials: true,
    });
    return setTutors(tutorRequest.data);
  };

  // Dismiss Message
  const dismissMessages = () => {
    setSuccessMessage("");
    return setErrorMessage("");
  };

  return (
    <div className='TutorList'>
      <FadeIn delay={250} duration={450}>
        {isAuthenticated() ? (
          <Container className='text-center'>
            <Row>
              <Col sm='12'>
                <h2>Your Tutors</h2>
                <div>
                  <StatusBlock
                    errorMessage={errorMessage}
                    successMessage={successMessage}
                    dismissMessages={dismissMessages}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm='12' className='text-center'>
                <ViewModeButtons setViewMode={setViewMode} viewMode={viewMode} />
              </Col>
            </Row>
            {viewMode === "view" && (
              <TutorBoxes
                tutors={tutors}
                fetchNewData={fetchNewData}
                setSubmitClicked={setSubmitClicked}
                submitClicked={submitClicked}
                setErrorMessage={setErrorMessage}
                setTutorForEdit={setTutorForEdit}
                setViewMode={setViewMode}
                setSuccessMessage={setSuccessMessage}
              />
            )}
            {viewMode === "add" && (
              <TutorAddForm
                fetchNewData={fetchNewData}
                setSubmitClicked={setSubmitClicked}
                submitClicked={submitClicked}
                setErrorMessage={setErrorMessage}
                setViewMode={setViewMode}
                setSuccessMessage={setSuccessMessage}
              />
            )}
            {viewMode === "edit" && (
              <TutorEditForm
                tutors={tutors}
                fetchNewData={fetchNewData}
                setSubmitClicked={setSubmitClicked}
                submitClicked={submitClicked}
                setErrorMessage={setErrorMessage}
                tutorForEdit={tutorForEdit}
                setViewMode={setViewMode}
                setSuccessMessage={setSuccessMessage}
              />
            )}
          </Container>
        ) : (
          <Navigate to='/admin/' />
        )}
      </FadeIn>
    </div>
  );
};

const TutorBoxes = (props) => {
  const tutorEditButton = (_id, e) => {
    e.preventDefault();
    props.setTutorForEdit(_id);
    return props.setViewMode("edit");
  };
  const deleteTutor = async (_id, e) => {
    e.preventDefault();
    props.setSubmitClicked(true);
    const deleteTutorRequest = await axios.delete(`/api/admin/manage/tutor/${_id}`, {
      withCredentials: true,
    });
    if (deleteTutorRequest.status === 200) {
      props.setSubmitClicked(false);
      window.scrollTo(10, 0);
      props.setSuccessMessage("Successfully deleted tutor.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      window.scrollTo(10, 0);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };
  return (
    <Row>
      {props.tutors.map((tutor) => (
        <Col key={tutor._id} sm='12' lg='6'>
          <FadeIn delay={50} duration={450}>
            <div className='mx-1 mt-3 p-2 shadow text-center border'>
              <h3>{`${tutor.First_Name} ${tutor.Last_Name}`}</h3>
              <span>{tutor.email}</span>
              <hr />
              <Button
                variant='primary'
                className='me-1 mb-2'
                onClick={(e) => tutorEditButton(tutor._id, e)}
              >
                Edit <MdModeEdit />
              </Button>
              <TutorPasswordReset
                setSubmitClicked={props.setSubmitClicked}
                submitClicked={props.submitClicked}
                setErrorMessage={props.setErrorMessage}
                setViewMode={props.setViewMode}
                setSuccessMessage={props.setSuccessMessage}
                _id={tutor._id}
              />
              <Button
                variant='danger'
                className='ms-1 mb-2'
                onClick={(e) => deleteTutor(tutor._id, e)}
                disabled={props.submitClicked}
              >
                Delete <MdOutlineCancel />
              </Button>
            </div>
          </FadeIn>
        </Col>
      ))}
    </Row>
  );
};


const TutorPasswordReset = (props) => {
  const resetPassword = async () => {
    const data = {
      _id: props._id,
    };
    // Make the API call
    const requestNewEmail = await axios.post("/api/admin/manage/tutor/reset", data, {
      withCredentials: true,
    });
    if (requestNewEmail.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully sent reset email.");
      return window.scrollTo(10, 0);
    } else {
      props.setSubmitClicked(false);
      window.scrollTo(10, 0);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  return (
    <Button
      variant='warning'
      className='ms-1 mb-2'
      type='button'
      disabled={props.submitClicked}
      value={props._id}
      onClick={() => resetPassword()}
    >
      Reset Password <MdPassword/>
    </Button>
  );
};

const TutorEditForm = (props) => {
  // Extract the data from the selected tutor
  const tutorSelected = props.tutors.find((x) => {
    return x._id === props.tutorForEdit;
  });
  const [First_Name, setFirst_Name] = useState(tutorSelected.First_Name);
  const [Last_Name, setLast_Name] = useState(tutorSelected.Last_Name);
  const [email, setEmail] = useState(tutorSelected.email);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      _id: tutorSelected._id,
      email,
      First_Name,
      Last_Name,
    };
    // Make the API call
    const requestEdit = await axios.put("/api/admin/manage/tutor/edit", data, {
      withCredentials: true,
    });
    if (requestEdit.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Successfully saved tutor.");
      window.scrollTo(10, 0);
      props.setViewMode("view");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      window.scrollTo(10, 0);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  return (
    <Row>
      <Col sm='12'>
        <FadeIn delay={50} duration={450}>
          <div className='mx-1 mt-3 p-2 shadow text-center border'>
            <Form className='post' onSubmit={handleSubmit}>
              <Row>
                <Col sm='6' className='mt-2'>
                  <Form.Group controlId='TutorNameForm'>
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type='text'
                      maxLength='256'
                      value={First_Name}
                      onChange={(e) => setFirst_Name(e.target.value)}
                      className='border'
                    />
                    <Form.Text className='text-muted'>The tutors first name.</Form.Text>
                  </Form.Group>
                </Col>
                <Col sm='6' className='mt-2'>
                  <Form.Group controlId='TutorNameForm'>
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type='text'
                      maxLength='256'
                      value={Last_Name}
                      onChange={(e) => setLast_Name(e.target.value)}
                      className='border'
                    />
                    <Form.Text className='text-muted'>The tutors last name.</Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col className='mt-2'>
                  <Form.Group controlId='LessonTitleForm' className='mt-3'>
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      value={email}
                      onChange={(e) => setEmail(e.target.value.toLowerCase())}
                      required
                      style={{ textTransform: "lowercase" }}
                      type='email'
                      className='border'
                    />
                    <Form.Text className='text-muted'>
                      The tutor will be able to set their password using the reset password
                      functionality.
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              <Col className='mt-2 mb-2'>
                <Button variant='success' type='submit' disabled={props.submitClicked}>
                  Save
                </Button>
              </Col>
            </Form>
          </div>
        </FadeIn>
      </Col>
    </Row>
  );
};

const ViewModeButtons = (props) => {
  if (props.viewMode === "add" || props.viewMode === "edit") {
    return (
      <FadeIn delay={50} duration={450}>
        <Button
          variant='secondary'
          value='view'
          className='m-1'
          onClick={(e) => props.setViewMode(e.target.value)}
        >
          <MdOutlineCancel />
          Return
        </Button>
      </FadeIn>
    );
  } else {
    return (
      <FadeIn delay={50} duration={450}>
        <Button
          variant='primary'
          value='add'
          className='m-1'
          onClick={(e) => props.setViewMode(e.target.value)}
        >
          <MdAddCircle />
          Add a Tutor
        </Button>
      </FadeIn>
    );
  }
};

export default TutorList;
